module.exports = require("redux-immutable");


//////////////////
// WEBPACK FOOTER
// external "redux-immutable"
// module id = 531
// module chunks = 0